<template>
    <div class="contact">
        <v-container fluid style="padding-top: 70px;">
            <v-img style="height:400px" src="../assets/bar2.jpg">
                <v-row align="end" class="lightbox white--text pa-2 fill-height">
                    <v-col>
                        <v-container>
                            <div class="display-2 font-weight-bold">Contacto</div>
                        </v-container>
                    </v-col>
                </v-row>
            </v-img>
        </v-container>
        <v-container>
            <v-row style="margin-top: 50px !important;">
                <v-col cols="12" sm="6">
                    <h2>Titulo</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                </v-col>
                <v-col cols="12" sm="6">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4332.457210871!2d3.119660166115364!3d39.84040536964019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12962c9474f5e84b%3A0xa353520adf231ec8!2sCarretera%20d&#39;Art%C3%A0%2C%2038%2C%2007400%20Alc%C3%BAdia%2C%20Illes%20Balears%2C%20Espa%C3%B1a!5e0!3m2!1ses-419!2suy!4v1590099956553!5m2!1ses-419!2suy" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <Form />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Form from '@/components/Form.vue'
export default {
    name: 'Contact',
    data() 
    {
        return {
            tracking: [
                {
                    latitude: "39.827713",
                    longitude: "3.115498"
                }
            ]
        }
    },
    components: {
        Form
    },
}
</script>

<style>

</style>